export default __webpack_public_path__ + "05eafe002e02ec5d131172613286e348.png";